export default {
  'k-2': true,
  '3-5': true,
  '6-8': true,
}
